<mat-card class="top-card summary-card mat-elevation-z0 black-border-color">
  <div class="price-summary-header">
    <div class="flex-0-5">
      Jobnr
    </div>
    <div class="flex-0-75">
      Aanvraag
    </div>
    <div class="flex-4">
      Omschrijving
    </div>
    <div class="flex-1-5">
      <div class="price-label-container">
        <div class="price-label">
          <div class="d-flex">
            <div>
              Prijs
            </div>
            <mat-icon
              class="price-warning-icon"
              *ngIf="atLeastOneNonStandardPrice"
              matTooltip="Er is minstens één component zonder standaard prijs. De prijs van zulke componenten wordt hier niet getoond."
              >report_problem</mat-icon
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngFor="let product of project.products; let first = first">
    <ng-container *ngIf="product.type === CLIENT_WINDOW_STICKER_TYPE">
      <ng-container
        *ngTemplateOutlet="
          windowSticker;
          context: {
            windowSticker: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.BOARD.value">
      <ng-container
        *ngTemplateOutlet="
          board;
          context: {
            board: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.OTHER_PRODUCT.value">
      <ng-container
        *ngTemplateOutlet="
          otherProduct;
          context: {
            otherProduct: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.IP_BOARD.value">
      <ng-container
        *ngTemplateOutlet="
          ipBoard;
          context: {
            ipBoard: product,
            project: project,
            baseProject: baseProject,
            first: first,
            divergentPricesOnly: divergentPricesOnly
          }
        "
      ></ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="toShowPriceLines?.length > 0">
    <div *ngFor="let priceLine of toShowPriceLines" class="price-summary-row">
      <div class="flex-0-5"></div>
      <div class="flex-0-75"></div>
      <div class="flex-4">
        {{ priceLine.text }}
      </div>
      <div class="flex-1-5 horizontal-center">
        <span class="price-display"
          >{{ priceLine.price | asFormatDecimal: true:2 }} €</span
        >
      </div>
    </div>
  </ng-container>
</mat-card>

<ng-template
  #windowSticker
  let-windowSticker="windowSticker"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <div class="price-summary-row">
    <div class="flex-0-5">
      <span *ngIf="first" class="secondary-color strong">{{
        project.id | or
      }}</span>
    </div>
    <div class="flex-0-75">
      <span *ngIf="first">{{ createdDate | date: 'dd.MM.yyyy' }}</span>
    </div>
    <div class="flex-4">
      <span class="secondary-color strong"
        >{{ windowSticker.calculatedTypeLabel }},
        {{
          windowSticker.clientStickerParts?.length > 0 &&
          windowSticker.clientStickerParts[0].partType ===
            CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART
            ? (windowSticker.clientStickerParts[0].instance?.productSize
                ?.height
              | joiner
                : 'x'
                : windowSticker.clientStickerParts[0].instance?.productSize
                    ?.width)
            : windowSticker.clientStickerParts?.length > 0 &&
              windowSticker.clientStickerParts[0].partType ===
                CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART
            ? (windowSticker.clientStickerParts[0].instance?.stickerHeight
              | joiner
                : 'x'
                : windowSticker.clientStickerParts[0].instance?.stickerWidth)
            : '-'
        }}</span
      >
      <div *ngIf="first && baseProject.projectPlacement?.address != null">
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </div>
    <div class="flex-1-5 horizontal-center">
      <span class="price-display"
        >{{
          windowSticker.clientStickerParts?.length === 1 &&
          windowSticker.clientStickerParts[0].partType ===
            CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART &&
          windowSticker.clientStickerParts[0].instance?.productSize != null
            ? (windowSticker.clientStickerParts[0].instance.productSize
                .productionPrice
              | sum
                : windowSticker.clientStickerParts[0].instance.productSize
                    .placementPrice)
            : '-'
        }}
        €</span
      >
    </div>
  </div>
</ng-template>

<ng-template
  #board
  let-board="board"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <div *ngIf="board.atLeastOneStandardPart" class="price-summary-row">
    <div class="flex-0-5">
      <span *ngIf="first" class="secondary-color strong">{{
        project.id | or
      }}</span>
    </div>
    <div class="flex-0-75">
      <span *ngIf="first">{{ createdDate | date: 'dd.MM.yyyy' }}</span>
    </div>
    <div class="flex-4">
      <ng-container *ngIf="board.boardParts != null">
        <ng-container *ngFor="let part of board.boardParts">
          <div *ngIf="part.signSize != null">
            <span class="secondary-color strong">{{
              part.boardType?.label
                | joiner: ' ':(part.placementType?.label | lowercase)
            }}</span>
            <span class="secondary-color strong"
              >, {{ part.height | joiner: 'x':part.width }}</span
            >
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="first && baseProject.projectPlacement?.address != null">
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="board.boardParts != null">
        <ng-container *ngFor="let part of board.boardParts">
          <div *ngIf="part.signSize != null">
            <span class="price-display"
              >{{
                part.signSize.productionPrice
                  | sum
                    : part.signSize.placementPrice
                    : (part.paintedPosts
                        ? part.signSize.paintedPostsPrice
                        : '0')
              }}
              €</span
            >
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template
  #otherProduct
  let-otherProduct="otherProduct"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <div class="price-summary-row">
    <div class="flex-0-5">
      <span *ngIf="first" class="secondary-color strong">{{
        project.id | or
      }}</span>
    </div>
    <div class="flex-0-75">
      <span *ngIf="first">{{ createdDate | date: 'dd.MM.yyyy' }}</span>
    </div>
    <div class="flex-4">
      <span class="secondary-color strong"
        >{{ otherProduct.otherProductName | or: 'Andere' }},
        {{
          otherProduct.height | joiner: 'x':otherProduct.width | or: '-'
        }}</span
      >
      <div *ngIf="first && baseProject.projectPlacement?.address != null">
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </div>
    <div class="flex-1-5 horizontal-center">
      <span class="price-display"
        >{{
          windowSticker.clientStickerParts?.length === 1 &&
          windowSticker.clientStickerParts[0].partType ===
            CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART &&
          windowSticker.clientStickerParts[0].instance?.productSize != null
            ? (windowSticker.clientStickerParts[0].instance.productSize
                .productionPrice
              | sum
                : windowSticker.clientStickerParts[0].instance.productSize
                    .placementPrice)
            : '-'
        }}
        €</span
      >
    </div>
  </div>
</ng-template>

<ng-template
  #ipBoard
  let-ipBoard="ipBoard"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
  let-divergentPricesOnly="divergentPricesOnly"
>
  <div class="price-summary-row">
    <div class="flex-0-5">
      <span *ngIf="first" class="secondary-color strong">{{
        project.id | or
      }}</span>
    </div>
    <div class="flex-0-75">
      <span *ngIf="first">{{ createdDate | date: 'dd.MM.yyyy' }}</span>
    </div>
    <div class="flex-4">
      <div *ngIf="collaborativeCompanyNames?.length > 0" class="under-space">
        <span class="strong"
          >Gezamenlijk bord: {{ collaborativeCompanyNames }}</span
        >
      </div>
      <div>
        <span class="secondary-color strong">{{
          ipBoard.boardPart?.sign?.type?.value ===
            SIGN_TYPE_CHOICES.STICKER.value ||
          ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
            ? 'Kleefbord'
            : (ipBoard.boardPart?.boardType?.label
              | joiner
                : ' - '
                : (ipBoard.boardPart.placementType?.ordinal
                    | ipBoardPlacementTypeOrAlternative
                      : ipBoard.boardPart.placementType?.label
                      : ipBoard.boardPart.alternativePlacementType
                      : 'Andere plaatsingsmethode'
                    | shortenText: 50))
        }}</span>
        <span class="secondary-color strong"
          >,
          {{
            ipBoard.boardPart?.sign?.type?.value ===
              SIGN_TYPE_CHOICES.STICKER.value ||
              ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
                IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
              | formatIPBoardDimensions
                : ipBoard.boardPart?.sign?.signMeasurements?.height
                : ipBoard.boardPart?.sign?.signMeasurements?.width
                : ipBoard.boardPart?.sign?.shape?.value ===
                    SIGN_SHAPE_TYPE_CHOICES.UPRIGHT.value
                : ipBoard.boardPart?.otherHeight
                : ipBoard.boardPart?.otherWidth
          }}</span
        >
      </div>
      <div *ngIf="first && baseProject.projectPlacement?.address != null">
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container
        *ngIf="ipBoardPlacementPrice != null && !divergentPricesOnly && !client"
      >
        <span class="price-display"
          >{{ ipBoardPlacementPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardPlacementPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container
        *ngIf="ipBoardPlacementPrice != null && !divergentPricesOnly && client"
      >
        <span class="price-display"
          >{{
            ipBoardPlacementPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="ipBoardProductionPrice != null && !divergentPricesOnly"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">Aanmaakkost</div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardProductionPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardProductionPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardProductionPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="!divergentPricesOnly && ipBoardTextPrice != null"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">+ Tekst: {{ ipBoard.boardPart.customText }}</div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardTextPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardTextPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardTextPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="!divergentPricesOnly && ipBoardCustomTitlePrice != null"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + Aangepaste titel
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardCustomTitlePrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardCustomTitlePrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardCustomTitlePrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="!divergentPricesOnly && ipBoardCustomPhoneNumberPrice != null"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + Aangepast telefoonnummer
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardCustomPhoneNumberPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardCustomPhoneNumberPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardCustomPhoneNumberPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="!divergentPricesOnly && ipBoardCustomStickerPrice != null"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + Aangepaste sticker
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardCustomStickerPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardCustomStickerPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardCustomStickerPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="ipBoard.extraBoard != null && !divergentPricesOnly"
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + {{ ipBoard.extraBoard.label }}:
      {{ ipBoard.extraBoardText | shortenText }}
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{ ipBoardExtraBoardPrice | asFormatDecimal: true:2 }} €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardExtraBoardPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardExtraBoardPrice
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="
      baseProject.projectPlacement.secondBoard != null && !divergentPricesOnly
    "
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      <ng-container
        *ngIf="
          baseProject.projectPlacement.secondBoard.secondBoardCopy &&
          project.products?.length > 0
        "
      >
        Tweede bord:
        {{
          project.products[0].boardPart?.boardType?.label
            | joiner
              : ' '
              : (project.products[0].boardPart?.placementType?.label
                  | lowercase)
        }}
      </ng-container>
      <ng-container
        *ngIf="!baseProject.projectPlacement.secondBoard.secondBoardCopy"
      >
        Tweede bord:
        {{
          baseProject.projectPlacement.secondBoard.secondBoardConfiguration
            | shortenText
        }}
      </ng-container>
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-container *ngIf="!client">
        <span class="price-display"
          >{{
            ipBoardPlacementPrice +
              ipBoardTotalPrice -
              secondBoardPlacementDiscount | asFormatDecimal: true:2
          }}
          €</span
        >
        <span *ngIf="distinctCompanyFactor < 1" class="price-display"
          >&nbsp;(/{{ numDistinctCompanies }} =
          {{
            ipBoardPlacementPrice +
              ipBoardTotalPrice -
              secondBoardPlacementDiscount
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €)</span
        >
      </ng-container>
      <ng-container *ngIf="client">
        <span class="price-display"
          >{{
            ipBoardPlacementPrice +
              ipBoardTotalPrice -
              secondBoardPlacementDiscount
              | multiply: distinctCompanyFactor
              | asFormatDecimal: true:2
          }}
          €</span
        >
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="
      !divergentPricesOnly &&
      (ipBoard.productPlacement?.arrows?.amountArrowsLeft > 0 ||
        ipBoard.productPlacement?.arrows?.amountArrowsRight)
    "
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + Pijlen
    </div>
    <div class="flex-1-5 horizontal-center">
      <ng-template
        let-arrowAmount="arrowAmount"
        [ngTemplateOutletContext]="{
          arrowAmount:
            ((ipBoard.productPlacement?.arrows?.amountArrowsLeft != null
              ? ipBoard.productPlacement?.arrows?.amountArrowsLeft
              : 0) +
              (ipBoard.productPlacement?.arrows?.amountArrowsRight != null
                ? ipBoard.productPlacement?.arrows?.amountArrowsRight
                : 0)) *
            11
        }"
        [ngTemplateOutlet]="arrows"
        #arrows
      >
        <ng-container *ngIf="!client">
          <span class="price-display"
            >{{ arrowAmount | asFormatDecimal: true:2 }} €</span
          >
          <span *ngIf="distinctCompanyFactor < 1" class="price-display">
            &nbsp;(/{{ numDistinctCompanies }} =
            {{
              arrowAmount
                | multiply: distinctCompanyFactor
                | asFormatDecimal: true:2
            }}
            €)
          </span>
        </ng-container>
        <ng-container *ngIf="client">
          <span class="price-display"
            >{{
              arrowAmount
                | multiply: distinctCompanyFactor
                | asFormatDecimal: true:2
            }}
            €</span
          >
        </ng-container>
      </ng-template>
    </div>
  </div>
  <div
    *ngIf="
      !project.collaborative && ipBoard.draftDesign && !divergentPricesOnly
    "
    class="price-summary-row"
  >
    <div class="flex-0-5"></div>
    <div class="flex-0-75"></div>
    <div class="flex-4">
      + Ik wens eerst een ontwerp te ontvangen
    </div>
    <div class="flex-1-5 horizontal-center">
      <span class="price-display">15,00 €</span>
    </div>
  </div>
</ng-template>
